import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionCheckerService } from '../services/permission-checker/permission-checker.service';

@Injectable({
  providedIn: 'root'
})
export class CanEditSurveyCustomerAddressGuard  {
  
  constructor(private router: Router, 
    private permissionChecker: PermissionCheckerService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.canAccessPage();
  }
  
  async canAccessPage(): Promise<boolean | UrlTree> {

    var canCRUDCustomerLocations = await this.permissionChecker.canCRUDCustomerLocations();
    if (canCRUDCustomerLocations) {
      return true;
    }
    else {
      return this.router.parseUrl('/dashboard');
    }
    
  }
  
}
